import {
    faBookAtlas,
    faCalendarDays,
    faDumbbell,
    faFolder,
    faHomeLg,
    faKey,
    faLayerGroup,
    faShoppingCart,
    faTimes,
    faUser,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactNode, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useMenu } from '../../../context/MenuContext'
import { useClickOutside } from '../../../hooks/useClickOutside'
import { useLangSelected } from '../../../hooks/useLangSelected'
import AdminContainer from '../../admin/AdminContainer'
import { CloseButton, SideBar, SidebarLink } from './MemberSideBar'

interface SidebarProps {
    children: ReactNode
    isOpen?: boolean
}

export const CoachSideBar = ({ children, isOpen = false }: SidebarProps) => {
    const { closeMenu } = useMenu()
    const sidebarRef = useRef<HTMLDivElement>(null)

    useClickOutside(sidebarRef, closeMenu)
    const location = useLocation()

    let lng = useLangSelected()

    const { t } = useTranslation()

    return (
        <>
            <SideBar ref={sidebarRef} isOpen={isOpen}>
                <CloseButton onClick={closeMenu}>
                    <FontAwesomeIcon icon={faTimes} />
                </CloseButton>
                <SidebarLink
                    to={`${lng}/bva-coach`}
                    className={location.pathname === `/${lng}/bva-coach` ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faHomeLg} /> {t('sidebar.admin.dashboard')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/mes-membres`}
                    className={location.pathname.includes(`/${lng}/bva-coach/mes-membres`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faUser} /> {t('coach.my-members')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/competences`}
                    className={location.pathname.includes(`/${lng}/bva-coach/competences`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faBookAtlas} /> {t('coach.skills')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/categories-competences`}
                    className={location.pathname.includes(`/${lng}/bva-coach/categories-competences`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faFolder} /> {t('coach.parentSkills')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/exercises`}
                    className={location.pathname.includes(`/${lng}/bva-coach/exercises`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faDumbbell} /> {t('coach.exercises.title')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/seances`}
                    className={location.pathname.includes(`/${lng}/bva-coach/seances`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faCalendarDays} />
                    {t('sidebar.admin.training-sessions')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/groupes-seances`}
                    className={location.pathname.includes(`/${lng}/bva-coach/groupes-seances`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faLayerGroup} />
                    {t('sidebar.admin.training-session-groups')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/modifier-mon-mot-de-passe`}
                    className={location.pathname === `/${lng}/bva-coach/modifier-mon-mot-de-passe` ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faKey} /> {t('sidebar.member.password')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-coach/shop`}
                    className={location.pathname.includes(`/${lng}/bva-coach/shop`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faShoppingCart} /> {t('shop.title')}
                </SidebarLink>
            </SideBar>
            <AdminContainer>{children}</AdminContainer>
        </>
    )
}

export default CoachSideBar
